<template>
    <div>
        <Menu style="width: fit-content;z-index: 1004; padding: 10px;" ref="menu" :model="menuItems" :popup="true" @itemClick="handleMenuItemClick" />
    </div>
</template>
  
<script>
import Menu from 'primevue/menu';

export default {
    components: {
        Menu,
    },
    props: ['options', 'menuType'],
    computed: {
     menuItems() {
      if(!this.options || this.options.length == 0){
          return []
      }

      if (this.menuType === 'issueType') {
        return this.options.map(option => ({
          label: option.name,
          command: () => this.handleMenuItemClick(option.id,{"issue_type_name":option.name}),
        }));
      }
      if (this.menuType === 'stage') {
        return this.options.map(option => ({
          label: option.name,
          command: () => this.handleMenuItemClick(option.code),
        }));
      } else {
        return this.options.map(option => ({
          label: option.display_value,
          command: () => this.handleMenuItemClick(option.data_value),
        }));
      }
    },
    },
    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        handleMenuItemClick(Value,value2) {
            this.$emit('optionselected', Value,value2)
        },
    },
};
</script>
<style>
.p-menu .p-menuitem-link {
  display: block !important;
}

.p-menu .p-menuitem-link:hover{
  background-color: #83838479;
  padding: 2px 4px;
}
</style>
  

